// extracted by mini-css-extract-plugin
export default {"selector":"PokemonSlot_selector__7cpqp","info":"PokemonSlot_info__dj2wG","image":"PokemonSlot_image__-IAhx"};